import { OCC_REPORT_TYPE_LABELS, type ReportType } from '../../types/documentTypes.generated';

/**
 * Marcação de documentos dos riscos (#606, D7). A regra é a do motor dos documentos: o risco sem
 * documento marcado sai em todos os documentos; o marcado sai só nos marcados. A marcação de um
 * risco não muda onde os outros saem.
 */

/** "PGR", "PCMSO", "LTP"; o eSocial guarda o evento, que é o que o distingue. */
export function rotuloCurtoDoDocumento(tipo: ReportType): string {
  return OCC_REPORT_TYPE_LABELS[tipo].replace(/ \((?!S-)[^)]*\)$/, '');
}

export function listaDeDocumentos(tipos: readonly ReportType[]): string {
  return tipos.map(rotuloCurtoDoDocumento).join(', ');
}

/** O que acontece se nada for marcado — no lugar do antigo "(opcional)". `onde`: "do cargo Soldador". */
export function textoSeNadaForMarcado(onde: string): string {
  return `Se nada for marcado, o risco aparece em todos os documentos ${onde}.`;
}
